// extracted by mini-css-extract-plugin
export var articleBodyStyle = "template_blog_article-module--articleBodyStyle--uSWpX";
export var outerWrapperStyle = "template_blog_article-module--outerWrapperStyle--MvBkI";